import React from 'react';
import { useSelector } from 'react-redux';
import { UserType } from '../../enums';
import CollectDataIndividual from './CollectDataIndividual';
import CollectDataCompany from './CollectDataCompany';

function CollectData() {
  const { user } = useSelector((state) => state.user);

  if (!user) {
    return null;
  }

  return <div className='bg-[#EBF4FB] sm:min-h-screen'>{user.userType === UserType.Company ? <CollectDataCompany /> : <CollectDataIndividual />}</div>;
}

export default CollectData;
